export type ProStatus = 'online' | 'busy' | 'offline' | 'paused';

export interface StatusDisplay {
  label: string;
  /** Tailwind bg class for the presence dot. */
  dotClass: string;
  /** Tailwind classes for the pill/badge. */
  badgeClass: string;
  /** Whether the dot should pulse (only when actively available). */
  pulse: boolean;
}

/**
 * Presence display for a professional in the user-facing lists.
 * `busy` (in a call) is distinct from `offline`: amber "In chiamata".
 */
export function professionalStatusDisplay(status: ProStatus | undefined): StatusDisplay {
  switch (status) {
    case 'online':
      return { label: 'Online', dotClass: 'bg-emerald-400', badgeClass: 'bg-emerald-500/15 text-emerald-600', pulse: true };
    case 'busy':
      return { label: 'In chiamata', dotClass: 'bg-amber-400', badgeClass: 'bg-amber-500/15 text-amber-600', pulse: false };
    case 'paused':
      return { label: 'In pausa', dotClass: 'bg-brand-orange', badgeClass: 'bg-brand-orange/15 text-brand-orange', pulse: false };
    default:
      return { label: 'Offline', dotClass: 'bg-neutral-400', badgeClass: 'bg-neutral-100 text-neutral-400', pulse: false };
  }
}
